module.exports = __webpack_public_path__ + "static/img/reward_effect_pre3.212c9bb4.png";